"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteDroplet = void 0;
const deleteDroplet = ({ httpClient, }) => ({ droplet_id, }) => {
    const path = '/droplets';
    const url = `${path}/${droplet_id}`;
    return httpClient.delete(url);
};
exports.deleteDroplet = deleteDroplet;
//# sourceMappingURL=delete-droplet.js.map